import Vue from "vue";
import Reservation from "@/components/shared/GuestForm/Model/Reservation";
import {
  FlashMessageService,
  Helper,
  CustomHeadersService,
  ApiClient
} from "zoox-infra";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import {
  CompanyService,
  ReservationService,
  CountryService,
  validationMixin
} from "smck-service";
import PersonService from "@/service/person-service";
import { mapActions, mapState } from "vuex";
import ReservationDataHeader from "@/components/shared/ReservationDataHeader";
import { zValidationGuestModal, zFlagNumber, FormMixin } from "zoox-components";
// import StrategyManager from "@/strategies/manager";

export default {
  name: "GuestListv2",
  mixins: [sessionMixin, validationMixin, FormMixin],
  props: {
    fieldSettingsData: {
      type: Object
    },
    enableRecognition: {
      type: Boolean
    },
    enableZooxpay: {
      type: Boolean
    },
    hasChargeToPayAtCheckin: {
      type: Boolean
    },
    reservation: {
      type: Object
    },
    companyName: {
      type: String
    },
    companyId: {
      type: String
    },
    orientationTexts: {
      type: Object
    }
  },
  components: {
    ReservationDataHeader,
    "z-validation-guest-modal": zValidationGuestModal,
    "z-flag-number": zFlagNumber
  },
  data() {
    return {
      guestId: "",
      reservationId: "",
      countryService: new CountryService(),
      reservationToShow: new Reservation(),
      reservationService: new ReservationService(Vue),
      companyService: new CompanyService(Vue),
      apiClient: new ApiClient(Vue),
      personService: new PersonService(),
      finalizedGuests: [],
      pendentGuests: [],
      allGuests: [],
      fnrhFormSettings: {},
      dialog: false,
      dialog2: false,
      dialog3: false,
      selectedGuest: null,
      showEmailField: false,
      guestEmailConfirmation: "",
      emailRules: [
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("TABLET.INVALID_EMAIL")
      ],

      showValidationModal: false,
      selectedModalGuest: {
        reservationId: "",
        guestId: ""
      },
      radioGroupSelectValidationModel: null,
      radioGroupSelectValidationLabels: [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ],
      validationModalStep: 0,
      validationCode: null,
      validationModalGuest: null,
      showBrowserModalRecomendation: false,
      showBrowserModalAlreadyFinished: false,
      guestComunicationOptions: null,
      smsConfig: {}
    };
  },
  computed: {
    ...mapState(["showSplashScreen", "isQualifiedGuest", "currentReservation"]),
    guestListContentTranslation() {
      try {
        return this.countryService.contentTranslation(
          this.orientationTexts.guestList,
          this.$i18n.locale
        );
      } catch (e) {
        return "";
      }
    }
  },
  watch: {
    reservation: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.reservationToShow = value;
        this.buildGuests(value);
      }
    }
  },
  async created() {
    this.fnrhFormSettings = await this.companyService.getFnrhFormSettings(
      this.companyId
    );
    this.dialog =
      this.pendentGuests &&
      this.pendentGuests.length > 0 &&
      this.fnrhFormSettings.accompanyingGuest;

    if (this.dialog) {
      this.dialog3 = true;
    } else {
      this.dialog2 = true;
    }
  },
  async mounted() {
    const $ctx = this;
    $ctx.reservationId = $ctx.$route.params.reservationId;
    $ctx.guestId = $ctx.$route.params.guestId;
    const company = $ctx.companyService.getLocalCompany(true);
    if (company) {
      $ctx.companyName = company.name;
    }

    $ctx.apiClient.get(`portal/${$ctx.companyId}/sms`).then(data => {
      if (data) {
        $ctx.smsConfig = Object.assign($ctx.smsConfig, data);
      }
    });

    Vue.$globalEvent.$on("languageChanged", () => {
      $ctx.radioGroupSelectValidationLabels = [
        $ctx.$t("PIN.SEND_MAIL"),
        $ctx.$t("PIN.SEND_SMS")
      ];
    });

    $ctx.$_gtagPlugin_trackEvent("ENTERED_GUEST_LIST", "PORTAL", $ctx.guestId);
  },
  methods: {
    ...mapActions([
      "$setCameFromRecon",
      "$setIsSamePersonFromRecon",
      "$setIsBackingStep",
      "$setIsQualifiedGuest",
      "$setAuthenticatedPersonGuestId",
      "$setCurrentGuest",
      "$setIsEditingOtherGuest"
    ]),

    numberInputMobile(val, index) {
      const lastIndexDdd = this.getLastIndexDdd(this.pendentGuests[index]);
      this.pendentGuests[index].mobilePhoneNumber = val
        ? val.substring(lastIndexDdd)
        : "";
      this.pendentGuests[index].mobileCityCode = val
        ? val.substring(0, lastIndexDdd)
        : "";
      this.pendentGuests[index].mobileCityCode = val
        ? val.substring(0, lastIndexDdd)
        : "";
    },
    ddiInputMobile(val, index) {
      this.pendentGuests[index].mobileCountryCode = val.phoneDial;
      this.pendentGuests[index].mobileCountryCode = val.phoneDial;
      this.pendentGuests[index].mobilePhoneMask = val.mobilePhoneMask;
      this.pendentGuests[index].mobilePhoneCountryCode = val.code;
    },
    onMobileMaskSelect(mask, index) {
      this.pendentGuests[index].mobilePhoneMask = mask;
    },

    openValidationModal(guest) {
      this.validationModalGuest = guest;
      this.showValidationModal = true;
    },

    closeValidationModal() {
      this.showValidationModal = false;
      this.validationModalStep = 0;
      this.validationModalGuest = null;
      this.radioGroupSelectValidationModel = null;
      this.showError = false;
    },
    async resendCode(radioGroupSelectValidationModelObj) {
      return this.sendCode(radioGroupSelectValidationModelObj);
    },
    async sendCode(radioGroupSelectValidationModelObj) {
      if (radioGroupSelectValidationModelObj) {
        try {
          const resp = await this.apiClient.post(`v2/portal/send-code`, {
            contactId: radioGroupSelectValidationModelObj.id,
            reservationNumber: this.currentReservation.reservationNumber
          });

          if (resp.ok) {
            this.validationModalStep = 2;
            this.showError = false;
          }
        } catch (e) {
          FlashMessageService.warning(this.$t("PIN.WAIT_90_SECONDS"));
          console.error(e);
        }
      }
    },
    async getSelectedGuestPersonId() {
      const { reservationId, guestId, personId } = this.selectedModalGuest;
      if (personId != null) {
        if (
          !this.guestComunicationOptions &&
          this.selectedModalGuest.contactInfoList
        )
          this.guestComunicationOptions = this.selectedModalGuest.contactInfoList;
        else {
          this.guestComunicationOptions = (
            await this.reservationService.getPersonId(reservationId, guestId)
          ).contactInfoList;
        }
        return personId;
      }

      const resp = await this.reservationService.getPersonId(
        reservationId,
        guestId
      );

      if (resp !== "Person not found.") {
        this.guestComunicationOptions = resp.contactInfoList;
        return resp.personId;
      }
      return -1;
    },
    async open(guest) {
      this.selectedGuest = { ...guest };
      this.selectedModalGuest = {
        reservationId: this.currentReservation.id,
        guestId: guest.id,
        personId: guest.personId,
        contactInfoList: guest.contactInfoList
      };

      this.selectedModalGuest.personId = await this.getSelectedGuestPersonId();
      if (this.selectedModalGuest.personId !== -1) {
        if (
          this.isQualifiedGuest &&
          this.selectedModalGuest.guestId === this.$route.params.guestId
        ) {
          this.$setCurrentMobileStep(1);

          this.$redirectGuestView(
            this.$route.params.reservationId,
            this.selectedModalGuest.guestId
          );
        } else {
          this.openValidationModal(guest);
        }
      } else {
        localStorage.setItem("selectedGuestId", guest.id);
        this.editGuest(this.selectedGuest);
      }
    },
    reconSuccessForUserRegistered: function(resp) {
      this.openFaceRecognitionModalForUserRegistered = false;
      this.guestComunicationOptions = resp.resp.lastReservations[0].guests.filter(
        x => x.hasOwnProperty("contactInfoList")
      )[0].contactInfoList;
      this.showValidationModal = true;
    },
    reconFailForUserRegistered: function() {
      this.openFaceRecognitionModalForUserRegistered = false;
    },
    checkValidationCode(validationObj) {
      if (validationObj.code && validationObj.code.length === 5) {
        this.loading = true;
        return this.apiClient
          .post(
            `portal/verify-code`,
            {
              contactId: validationObj.contactId,
              verificationCode: validationObj.code
            },
            null,
            false,
            false
          )
          .then(resp => {
            if (resp.token) {
              this.showValidationModal = false;
              CustomHeadersService.setCustomHeaders({
                Authorization: resp.token
              });

              const validated = {
                personId: resp.personId,
                validated: resp.validated
              };
              const res = this.reservationService.updateLocalGuest(
                this.selectedModalGuest.guestId,
                validated
              );
              this.$setCameFromRecon(false);
              this.$setIsSamePersonFromRecon(false);
              this.$setCurrentPhoto("");

              this.reservationService.setValidatedInfo(validated);
              this.$setCurrentReservation(res);
              this.$setIsQualifiedGuest(true);
              this.$setAuthenticatedPersonGuestId(
                this.selectedModalGuest.guestId
              );

              if (resp.personId) {
                this.$setCurrentPersonId(resp.personId);
              }

              Vue.$globalEvent.$emit("tabChange", 0);
              Vue.$globalEvent.$emit("resetGuestForm");
              this.$setIsBackingStep(false);
              this.$setCurrentMobileStep(1);

              localStorage.setItem(
                "selectedGuestId",
                this.selectedModalGuest.guestId
              );

              this.$redirectGuestView(
                this.$route.params.reservationId,
                this.selectedModalGuest.guestId
              );
            }
          })
          .catch(error => {
            this.loading = false;
            if (error.status === 401) {
              FlashMessageService.error(this.$t("NOVO_FLUXO.INCORRECT_PIN"));
            } else {
              FlashMessageService.error(this.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN"));
            }
          });
      }
    },

    goToFillFnrhWithoutRecognition() {
      this.closeValidationModal();
      this.editGuest(this.selectedGuest);
    },

    getPhotoUrl: function(guest) {
      return (
        guest.photoUrl || require("../../../assets/images/generic-user.jpg")
      );
    },
    openEmailDialog() {
      this.dialog = true;
      // this.dialog2 = true;
      // this.dialog3 = false;
    },
    buildGuests(reservation) {
      this.finalizedGuests = reservation.guests
        .filter(x => x.fnrhId || x.completed)
        .map(g => {
          return g;
        });

      this.pendentGuests = this.currentReservation.guests
        .filter(x => !x.fnrhId && !x.completed)
        .map(g => {
          return g;
        });
      this.allGuests = [
        ...this.finalizedGuests.map(guest => ({ ...guest, isFinalized: true })),
        ...this.pendentGuests.map(guest => ({ ...guest, isFinalized: false }))
      ];
    },
    getFullAddress: function(guest) {
      let address = "";

      if (guest.address) {
        address += guest.address;
      }

      if (guest.addressNumber) {
        address += `, ${guest.addressNumber}`;
      }

      if (guest.addressComplement) {
        address += ` - ${guest.addressComplement}`;
      }

      if (guest.neighborhood) {
        address += `, ${guest.neighborhood}`;
      }

      if (guest.zipCode) {
        address += `, ${guest.zipCode}`;
      }

      if (guest.cityName) {
        address += ` - ${guest.cityName}`;
      }

      if (guest.stateName) {
        address += ` - ${guest.stateName}`;
      }

      if (guest.countryName) {
        address += ` - ${guest.countryName}`;
      }

      return address;
    },
    getPhoneNumber: function(guest) {
      if (
        guest.mobileCountryCode &&
        guest.mobilePhoneNumber &&
        guest.mobilePhoneMask
      ) {
        return `+${
          guest.mobileCountryCode
        } ${Helper.maskString(
          guest.mobileCityCode + guest.mobilePhoneNumber,
          guest.mobilePhoneMask,
          { "#": /\d/ }
        )}`;
      } else if (guest.mobile) {
        return `+${
          guest.mobileCountryCode
        } ${Helper.maskString(
          guest.mobileCityCode + guest.mobilePhoneNumber,
          "(##) #####-####",
          { "#": /\d/ }
        )}`;
      }
      return "";
    },
    closeSelecteOptionModal() {
      this.dialog = false;
      this.editGuest(this.selectedGuest);
    },
    cleanGuestToFillBlankFNRH(guest) {
      guest.nationalityId = null;
      guest.nationalityName = "";
      guest.countryId = null;
      guest.countryName = "";
      guest.mobileCountryCode = null;
      guest.mobileCityCode = null;
      guest.mobilePhoneNumber = "";
      guest.ddi = null;
      guest.ddd = null;
      guest.phoneNumber = "";
      guest.zipCode = "";
      guest.cityId = null;
      guest.cityName = "";
      guest.stateId = null;
      guest.stateName = "";
      guest.address = "";
      guest.addressNumber = "";
      guest.addressComplement = "";
      guest.neighborhood = "";
      guest.arrivingFromCountryId = null;
      guest.arrivingFromCountryName = "";
      guest.arrivingFromStateId = null;
      guest.arrivingFromStateName = "";
      guest.arrivingFrom = null;
      guest.arrivingFromName = "";
      guest.nextDestinationCountryId = null;
      guest.nextDestinationCountryName = "";
      guest.nextDestinationStateId = null;
      guest.nextDestinationStateName = "";
      guest.nextDestination = null;
      guest.nextDestinationName = "";
      guest.arrivingBy = null;
      guest.arrivingByName = "";
      guest.purposeTrip = null;
      guest.purposeTripName = "";
      guest.gender = "";
      return guest;
    },
    editGuest: function(guest) {
      this.pendentGuests.email = "";
      this.pendentGuests.mobilePhoneNumber = "";
      this.$setCameFromRecon(false);
      this.$setIsSamePersonFromRecon(false);
      this.$setCurrentPhoto("");
      this.$setIsQualifiedGuest(false);
      if (guest.id !== this.guestId) {
        this.$setCurrentPersonId(null);
        guest = this.cleanGuestToFillBlankFNRH(guest);
        const index = this.reservation.guests.findIndex(g => g.id === guest.id);
        this.reservation.guests[index] = guest;
        this.$setCurrentReservation(this.reservation);
        this.$setCurrentGuest(guest);
        this.$setIsEditingOtherGuest(true);

        this.$router.push({
          name: "Home",
          params: {
            reservationId: this.reservationId,
            guestId: guest.id
          }
        });
        Vue.$globalEvent.$emit("tabChange", 0);
        Vue.$globalEvent.$emit("resetGuestForm", {
          guest,
          reservation: this.reservation
        });
        this.$setCurrentPhoto("");
        this.$setIsBackingStep(false);
        this.$setCurrentMobileStep(1);
      }
    },
    getFullName: function(guest) {
      return `${guest.name} ${guest.lastName}`;
    },
    async next() {
      this.$_gtagPlugin_trackEvent("GUEST_LIST_NEXT", "PORTAL", this.guestId);

      const localReservation = this.reservationService.getLocalReservation();
      const currentGuest = localReservation.guests.find(
        g => g.id === this.guestId
      );

      if (currentGuest != null) {
        if (
          currentGuest.sentWelcomeMail == null ||
          currentGuest.sentWelcomeMail === false
        ) {
          this.reservationService.sendWelcomeMail();
        }
      }

      await this.goToEnd();
    },
    async goToEnd() {
      await this.$router.push({ path: "/whatsapp-optin" });
    },
    openSelectOptionsModal(guest) {
      this.dialog = true;
      this.dialog2 = false;
      this.dialog3 = true;
      this.selectedGuest = guest;
    },
    openListFieldsToSendEmail() {
      this.dialog2 = true;
      this.dialog3 = false;
    },
    cancelSendEmail() {
      this.dialog2 = false;
      this.dialog3 = true;
    },
    async sendEmailToGuest() {
      this.dialog = false;
      try {
        const sentEmails = await Promise.all(
          this.pendentGuests
            .filter(
              x => x.email !== "" && x.email !== null && x.email !== undefined
            )
            .map(async g => {
              return await this.reservationService
                .sendCheckinEmailToGuest(this.reservationId, g)
                .then(resp => {
                  this.showEmailField = false;
                  this.guestEmailConfirmation = "";
                  return resp;
                });
            })
        );

        const sentSMSs = await Promise.all(
          this.pendentGuests
            .filter(
              (x =>
                x.mobilePhoneNumber !== "" &&
                x.mobilePhoneNumber !== null &&
                x.mobilePhoneNumber !== undefined) &&
                (x =>
                  x.mobileCountryCode !== "" &&
                  x.mobileCountryCode !== null &&
                  x.mobileCountryCode !== undefined) &&
                (x =>
                  x.mobileCityCode !== "" &&
                  x.mobileCityCode !== null &&
                  x.mobileCityCode !== undefined)
            )
            .map(async g => {
              g.mobile = `${g.mobileCountryCode}${g.mobileCityCode}${g.mobilePhoneNumber}`;
              return await this.apiClient.post(
                `reservation/guest/${this.reservationId}/checkinsms`,
                g
              );
            })
        );

        if (
          (sentEmails.length > 0 &&
            sentEmails.every(x => Object.keys(x).includes("messageId"))) ||
          (sentSMSs.length > 0 &&
            sentSMSs.every(x => x && x.output[0].statusCode === 200))
        ) {
          FlashMessageService.success(this.$t("GLOBAL.SEND_EMAIL_SMS_SUCCESS"));
        } else if (
          sentEmails.length > 0 &&
          sentEmails.some(x => !Object.keys(x).includes("messageId")) &&
          sentSMSs.length > 0 &&
          sentSMSs.some(x => x && x.output[0].statusCode !== 200)
        ) {
          FlashMessageService.error(this.$t("GLOBAL.SEND_EMAIL_SMS_FAIL"));
        }
        this.showEmailField = false;
        this.guestEmailConfirmation = "";
      } catch (e) {
        this.showEmailField = false;
        this.guestEmailConfirmation = "";
      }
    },
    getLastIndexDdd(guest) {
      /* eslint-disable no-useless-escape */

      guest.mobilePhoneMask = guest.mobilePhoneMask || "";
      const maskMobileCityCode = guest.mobilePhoneMask
        ? guest.mobilePhoneMask
            .replace(/[\(|\)]/g, "")
            .replace(/[-|\.|\/]/g, " ")
            .split(" ")[0]
        : "";
      if (guest.mobilePhoneMask.length === maskMobileCityCode.length) {
        return 0;
      }
      return maskMobileCityCode.length >= 4
        ? maskMobileCityCode.length - 2
        : maskMobileCityCode.length;
    }
  }
};
